<script setup>
import PointMap from '@/components/Maps/PointMap.vue';
import PointsMap from '@/components/Maps/PointsMap.vue';
import RegionsMap from '@/components/Maps/RegionsMap.vue';
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  isCarPage: {
    type: Boolean,
    default: false,
  },
});
</script>
<template>
  <div>
    <RegionsMap
      v-if="data.regions && data.regions.length > 0"
      :data="data"
      :is-car-page="isCarPage"
    />
    <PointMap
      v-else-if="data.items && data.items.length === 1"
      :data="data"
      :is-car-page="isCarPage"
    />
    <PointsMap v-else :data="data" :is-car-page="isCarPage" />
  </div>
</template>

<style scoped lang="scss"></style>
